module.exports = __webpack_public_path__ + "music.svg?6404918995fc9013b671b2a981d6cf5e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/music.svg
// module id = 115
// module chunks = 0